import { configureStore } from '@reduxjs/toolkit';
import applicationReducer from './reducers/applicationSlice.js';
import flowReducer from './reducers/flowSlice.js';
import variableReducer from './reducers/variablesSlice.js';
import executionReducer from './reducers/executionSlice.js';
import componentsReducer from './reducers/componentSlice.js';
import pagesReducer from './reducers/pagesSlice.js';
import compTreeReducer from './reducers/compTreeSlice.js';
import enginePropertiesReducer from './reducers/enginePropertiesSlice.js';
import globalComponentReducer from './reducers/globalComponentSlice.js';
import authReducer from './reducers/authSlice.js';

const store = configureStore({
    reducer: {
        Application: applicationReducer,
        auth: authReducer,
        components: componentsReducer,
        pages: pagesReducer,
        flows: flowReducer,
        compTree: compTreeReducer,
        variables: variableReducer,
        flowExecutions: executionReducer,
        engineProperties: enginePropertiesReducer,
        globalComponent: globalComponentReducer
    }
});

export { store };
//# sourceMappingURL=index.js.map
